var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAccount = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 .833A7.167 7.167 0 1 1 8 15.167 7.167 7.167 0 0 1 8 .833m0 1a6.167 6.167 0 1 0 0 12.332A6.167 6.167 0 0 0 8 1.835M8 3.5A2.5 2.5 0 0 1 10.5 6a2.5 2.5 0 0 1-.85 1.873 3.84 3.84 0 0 1 2.185 3.46.5.5 0 0 1-1 0 2.834 2.834 0 0 0-5.668 0 .5.5 0 0 1-1 0c0-1.525.892-2.843 2.182-3.46A2.5 2.5 0 0 1 5.5 6 2.5 2.5 0 0 1 8 3.5m0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
})));
export { SvgAccount as ReactComponent };
export default __webpack_public_path__ + "static/media/Account.0c3af919.svg";